import React from 'react'
import { View } from 'react-native'
import { CheckBox } from '../../../../components/CheckBox'

interface Props {
  onPress: () => void
  isCheck: boolean
  isSending: boolean
}

export const Header = ({ onPress, isCheck }: Props) => {
  return (
    <View style={{ paddingHorizontal: 24, flexDirection: 'row' }}>
      <View style={{ flex: 5 }}>
        <CheckBox
          isCheck={isCheck}
          onPress={onPress}
          item={{ id: 'all', name: 'Seleccionar todo' }}
        />
      </View>
      <View
        style={{
          flex: 1,
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      ></View>
    </View>
  )
}
